import $ from 'jquery';
import cytoscape from 'cytoscape';
import dagre from 'cytoscape-dagre';
import {
  contextPath,
  cloudFrontUrl,
  lDagreOptions,
  presetOptions,
  lCircleOption,
  lCoseOption,
  lConcentricOption,
  lElkOption,
} from './cy-constant';
import { collapseStyle, createCss, createNodeStyle, expandStyle } from './cy-css';
import { ADMIN_EMAIL } from '../../../constants/constants';

cytoscape.use(dagre);

let selectionType = 'single';
let zoomLevel; // = parseFloat($('#zoomLevel').text());//0.5;
const minZoom = 0.1;
const maxZoom = 2.5;
let searchPath;

let cy;

export const initCy = (userData) => {
  // debug-console.log('-------------- Init cy start ----------- userData=', userData);
  cy = cytoscape({
    container: document.getElementById('cy-container'), // container to render in
    elements: userData,
    style: createCss(userData),
    zoom: parseFloat($('#zoomLevel').text()),
    minZoom,
    maxZoom,
    // textureOnViewport : true,
    // motionBlur : true,
    layout: presetOptions, // lDagreOptions, // presetOptions,
  });

  // debug-console.log('-------------- Init cy completed ---------------', cy);
  return cy;
};

export const isAdmin = () => $('#userId').text() === ADMIN_EMAIL;

export const initView = () => {
  // debug-console.log('2. Start InitView. Remove offset Data');
  cy.nodes().removeData('offset').removeData('depth'); // .each(correctViewData);
  // cy.nodes().each(correctViewData);

  // cy.maxZoom( 0.5 );
  cy.zoom(zoomLevel);
  refreshSummary();
};

export const refreshSummary = () => {
  const nodes = cy.elements('node');
  // position();
  $('#nodeCount').text(nodes.length);
  const edges = cy.elements('edge');
  $('#edgeCount').text(edges.length);

  $('#elementCount').text(nodes.length + edges.length);
  // debug-console.log('___________ Refresh info : Total nodes = ', nodes.length);
  // cy.nodes().removeStyle('shape ghost').leaves().style(ghostStyle);
  // cy.nodes().removeClass('leaf').leaves().addClass('leaf');

  // lBfs();
  // cy.center();
  // cy.zoom(zoomLevel);

  // // debug-console.log('Current data : Elements = '+cy.elements().size());
  // // debug-console.log(JSON.stringify(cy.elements().jsons()));
};

export const bindDocumentEvent = () => {
  // debug-console.log('---------- bind Event');
  // Bind Ctrl Event:
  $(document).on('keydown', (e) => {
    if (e.ctrlKey) {
      selectionType = 'additive';
    }
  });

  $(document).on('keyup', (e) => {
    if (!e.ctrlKey) {
      selectionType = 'single';
    }
  });

  // On clicks, close suggestions:
  $(document).on('click', (e) => {
    // if (!$(e.target).hasClass('nodeSuggestion')) {
    // // debug-console.log('hide suggestion');
    $('.suggestions').text('').hide();

    // console.info(e.target, $(e.target).hasClass('panning-cls'));

    if (
      $('#panning-options').css('display') !== 'none' &&
      !$(e.target).hasClass('panning-cls') &&
      !$(e.target).parents().hasClass('panning-cls') &&
      !$(e.target).hasClass('ant-select-item-option-content')
    ) {
      $('#panning-options').hide();
    }
  });
};

export const correctTreeData = (treeData) => {
  // // debug-console.log('correct TreeData: Start');
  // // debug-console.log('correct TreeData:1. ----- Start correct TreeData ------ treeData=', treeData);
  // if (treeData && treeData.length > 0) {
  //   // debug-console.log('initCy:2. set userData=treeData');
  //   treeData = treeData;
  // }

  // including cy events
  if (!treeData) {
    treeData = [
      // list of graph elements to start with
      {
        data: { id: 'Loading', name: 'Loading' },
        position: { x: 100, y: 200 },
      },
    ];
  } else if (typeof treeData === 'string') {
    treeData = JSON.parse(treeData); // always array
  }

  treeData = treeData.map((ele) => {
    const nodeImg = ele?.data.img;
    if (nodeImg?.includes(cloudFrontUrl)) {
      const newData = { ...ele.data, img: nodeImg.replace(cloudFrontUrl, contextPath) };
      return { ...ele, data: newData };
      // // debug-console.log(ele.data.img + ' --> ');
      // ele.data.img = ele.data?.img.replace(cloudFrontUrl, contextPath);
      // // debug-console.log('--> ' + ele.data.img);
    }
    return { ...ele };
  });

  return treeData;
  // // debug-console.log('corrected data:', JSON.stringify(treeData));
  // return JSON.parse(JSON.stringify(treeData));
};
/*
  Render selected Node and relations' styles, populate Info tab
  Use for both Node and Edge, but now only using Node, so use AddNode
*/
const selectEle = (id, isFocused, isSelect) => {
  // // debug-console.log('Select Ele: ' + id + ' , isFocused= ' + isFocused);
  if (!id) {
    return;
  }

  let ele;
  if (typeof id === 'string') {
    ele = cy.getElementById(id);
    // } else if (id?.data?.id) {
    //   node = cy.getElementById(id.data.id);
    //   id = node.id();
  } else {
    ele = id; // input is an Element
    id = ele.id();
  }
  if (ele.length === 0) {
    // $('#controlPanel').fadeOut(1000);
    return;
  }
  // // debug-console.log(
  //   'Select ' +
  //     (node.isNode() ? 'Node' : 'Edge') +
  //     ' : Id= ' +
  //     id +
  //     ' , name= ' +
  //     node.data('name'),
  // );
  if (ele.isEdge()) {
    selectNode(ele.source(), isFocused); // temporary select src node for convenient
    // eles = eles.merge(node);
  } else {
    selectNode(ele, isFocused, !isSelect);
  }
};

const addEleInfo = (node) => {
  node.addClass('selected');
  const eleInfo = createEleButton(node);

  // add one if Ele Info not exist
  if ($('#selectingNodes span[node-id="' + node.id() + '"]').length === 0) {
    $('#selectingNodes').append(eleInfo.addClass('cy-ele'));
  }
};

export const selectNode = (node, isFocused, skipSelect) => {
  if (selectionType === 'single') {
    // unselect all nodes:
    clearSelection();
  }
  if (typeof node === 'string') {
    node = cy.nodes('#' + node);
  }
  // debug-console.log('select Node: ', node.data('name'));
  let selectedEles = cy.$(':selected').merge(node);

  updateNodeRelations(selectedEles);

  extractNodeInfo(node.id()); // to be replaced by extracting state in JSX
  updateSelection('.cy-ele', '.cy-ele[node-id="' + node.id() + '"]', 'border-green');

  if (isFocused === undefined || isFocused === null || isFocused) {
    onBtnFocus(cy);
  }

  if (!skipSelect) {
    node.select(); // highlight itself, default yes
  }
};

const updateNodeRelations = (selectedEles) => {
  // add .selecting node info
  const selectedNodes = selectedEles.nodes().forEach(addEleInfo);

  // connected edges :
  selectedNodes.connectedEdges().merge(selectedEles.edges()).sort(sortById).forEach(selectEdge);

  // nearest edges :
  selectedNodes.incomers('edge').addClass('red');

  // far edges :
  let incomersNodes = selectedNodes.incomers('node');
  let incomersEdges = incomersNodes.incomers('edge').filter((edge) => {
    // // debug-console.log('incomerEdge : '+ edge.id());
    return !edge.hasClass('selected');
  });
  // // debug-console.log('incomersEdges.length : '+ incomersEdges.length);
  while (incomersEdges.length > 0) {
    incomersEdges.addClass('ancient');
    incomersEdges = incomersNodes.incomers('edge').filter((edge) => {
      // // debug-console.log('incomerEdge : '+ edge.id());
      return !edge.hasClass('selected');
    });
    incomersNodes = incomersNodes.incomers('node');
    // // debug-console.log('incomersEdges.length : '+ incomersEdges.length);
  }

  selectedNodes.outgoers('edge').addClass('blue');
  // far nodes:
  let outgoersNodes = selectedNodes.outgoers('node');
  let outgoersEdges = outgoersNodes.outgoers('edge').filter((edge) => {
    // // debug-console.log('outgoersEdge : '+ edge.id());
    return !edge.hasClass('selected');
  });

  // // debug-console.log('outgoersEdges.length : '+ outgoersEdges.length);
  while (outgoersEdges.length > 0) {
    outgoersEdges.addClass('green');
    outgoersEdges = outgoersNodes.outgoers('edge').filter((edge) => {
      // // debug-console.log('outgoersEdge : '+ edge.id());
      return !edge.hasClass('selected');
    });
    outgoersNodes = outgoersNodes.outgoers('node');
    // // debug-console.log('outgoersEdges.length : '+ outgoersEdges.length);
  }
};

const selectEdge = (ele) => {
  // // debug-console.log(ele.id());
  ele.addClass('selected');

  // let eleInfo = createEleButton(ele);
  // if ($('#selecting span[node-id="' + ele.id() + '"]').length === 0) {
  //   // $('#selectingEdges').append(eleInfo); // skip because too much
  // }
};

// extract info to input fields to view, return cy Node
const extractNodeInfo = (id) => {
  $('#controlPanel').fadeIn(1000);
  $('#detail input[type="text"]').val('');
  const selection = cy.getElementById(id).first();
  if (selection.isNode()) {
    const node = selection;
    $('#nodeId').val(id);
    $('#cyNodeName').val(node.data('name'));
    $('#birthYear').val(node.data('birthYear'));
    $('#birthMonth').val(node.data('birthMonth'));
    $('#birthDay').val(node.data('birthDay'));

    const nodeImgUrl = node.data('img');
    $('#imgUrl').val(nodeImgUrl).attr('originalUrl', nodeImgUrl);
    $('#sourceNode,#sourceNode2').show();

    const gender = node.data('gender') === 'f' ? 'f' : 'm';
    $('[name=gender][value=' + gender + ']').prop('checked', true);

    if (node.data('isDead')) {
      $('[name=isDead][value=' + node.data('isDead') + ']').prop('checked', true);
    }

    node.incomers('edge').each((edge) => {
      const incomer = edge.source();
      // // debug-console.log('parent :',incomer);
      if (incomer.data('gender') === 'f') {
        $('#sourceNode2').hide();
        $('#mother').append(createRelationButton(incomer, edge));
      } else {
        $('#sourceNode').hide();
        $('#father').append(createRelationButton(incomer, edge));
      }
    });
    node.outgoers('edge').each((edge) => {
      const outgoer = edge.target();
      $('#children').append(createRelationButton(outgoer, edge));
    });
    $('#parentId').val(selection.data('parent'));
    $('#nodeData').val(JSON.stringify(selection.data()).replace(/,/g, ',\n'));
    $('#nodeId').text(id).attr('name', id);

    $('#controlPanel').show();
    $('#edgeDetail').hide();

    $('.connectedNode').show();
  } else if (selection.isEdge()) {
    $('#edgeId').val(id).attr('original-id', id);
    $('#edgeName').val(selection.data('name'));
    $('#edgeSource').val(selection.data('source'));
    $('#edgeTarget').val(selection.data('target'));

    $('#controlPanel').hide();
    $('#edgeDetail').show();
  }
  return selection;
};

// need a cyNode to get inner data:
const createRelationButton = (cyNode, edge) => {
  // // debug-console.log('createRelationBtn: node:' + cyNode.id() + ' - edge: ' + edge.id());
  return $('<div>')
    .addClass('cy-ele')
    .append(createEleButton(cyNode))
    .append(createRemoveEdgeButton(edge));
};

export const getNode = (nodeId) => {
  if (nodeId) {
    return cy?.getElementById(nodeId);
  }
  nodeId = $('#nodeId').val();
  if (nodeId.length > 0) {
    return cy?.getElementById(nodeId);
  }
  return null;
};

export const getNodeId = (e) => {
  if (e) {
    return $(e.target).attr('node-id');
  }
  return $('#nodeId').val();
};

function createRemoveEdgeButton(ele) {
  return $('<input>')
    .attr('type', 'submit')
    .attr('edge-id', ele.id())
    .val('X')
    .on('click', onBtnRemoveEdge)
    .addClass('btn');
}

export const removeNode = (nodeId) => {
  cy.getElementById(nodeId).remove();
};

// can use both 'this' (<input>) or e.target:
function onBtnRemoveEdge() {
  const edgeId = this.getAttribute('edge-id');
  // // debug-console.log('onBtnRemoveEdge ' + edgeId, this);
  const edge = cy.getElementById(edgeId);
  edge.remove();

  const eleInfoDiv = $(this).parent();
  $(this).prev().remove(); // span
  $(this).remove();

  const connectedNodeDiv = $(eleInfoDiv).parent();

  $(eleInfoDiv).remove();

  if (connectedNodeDiv.children().length === 0) {
    connectedNodeDiv.parent().find('input').show();
  }
}

function createEleButton(ele) {
  return (
    $('<span>')
      .attr('node-id', ele.id())
      .text(getDisplayName(ele))
      // .addClass('cy-ele')
      .click(selectNodeByAttrHandler)
  );
}

function selectNodeByAttrHandler(evt) {
  const id = $(evt.target).attr('node-id');
  selectNode(id, true, false);
}

export const getNodeData = (nodeId) => cy?.getElementById(nodeId).jsons();

// for debug purpose
export const getNodeCss = (nodeId) => cy?.getElementById(nodeId).style();

export const getCurrentConfig = () => {
  const space = $('#space').val();
  const size = $('#size').val() * 10;
  const shape = $('#shape').val();
  return { space, size, shape };
};

export const getCurrentTreeDataText = () => {
  const json = getCurrentTreeDataJson();
  if (json) {
    return JSON.stringify(json);
  }
  return '';
};

export const getCurrentTreeDataJson = () => {
  if (!cy) {
    return null;
  }
  // let data = JSON.stringify(cy.elements().jsons(), null, '\t'); // pretty
  // correctNodeId();
  // correctEdgeId();

  // cy.elements().removeData('offset').removeData('depth').removeData('weight');

  const userData = cy.elements().jsons();
  // .map((ele) => {
  //   const newData = {
  //     data: { ...ele.data },
  //     position: { ...ele.position },
  //     group: ele.group,
  //   };
  //   return newData;
  // });

  // var newWindow = window.open();
  // newWindow.html(userData);
  // debug-console.log('get currentTreeDataText: ', userData);
  return userData;
};

// auto arrange by default Dagre layout:
export const autoArrange = () => {
  // debug-console.log('-------- Auto arrange!');
  setTimeout(() => lDagreVisible(), 500);
};

export const getOrAddNode = (node) => {
  let result;
  if (node.id) {
    result = cy.nodes(`#${node.id}`);
  } else if (node.name) {
    result = getNodeByName(node.name);
  }

  if (result.empty()) result = addNode(node);
  return result;
};

// return cy Node object:
export const addNode = ({ id, name, gender, depth }) => {
  // // debug-console.log('add Node: name=', name);
  // let node = getNodeByName(name);

  // if (node.length === 0) {
  if (!id) id = Date.now().toString();
  const x = randInt(1000);
  const y = randInt(1000);
  // var name = id+ ' ('+x+','+y+')';
  const nodeData = {
    data: { id, name, depth, gender },
    position: { x, y },
  };
  const node = cy.add(nodeData);
  updateNodeStyle(nodeData);
  // debug-console.log('    <- Added new node: ', id, name);
  // } else {
  //   // debug-console.log('Element ' + name + ' already existed.', node);
  // }
  return node;
};

// reflect updates to cy
function updateNode(node, nodeId, parentId) {
  // debug-console.log('Update Node :' + node.id() + ', newId=' + nodeId);

  checkUpdateParent(node, parentId);

  // change Node's Id: not used
  if (nodeId !== node.id()) {
    changeNodeId(node, nodeId);
  }
  // node = extractNodeInfo(nodeId);

  // check upload img:
  const currentImgSrc = $('#imgDiv').find('img:not(.hide)').attr('src');

  if (currentImgSrc !== node.data('img')) {
    // // debug-console.log(`Update img: ${node.data('img')} -> ${currentImgSrc}`);
    updateNodeStyle({ data: { id: nodeId, img: currentImgSrc } });
  }

  refreshSummary();
}

const checkUpdateParent = (node, parentId) => {
  const parent = cy.getElementById(parentId);
  if (parentId === '') {
    parentId = null;
  }

  if (parentId && parent.empty()) {
    addNode({ name: parentId });
  } else if (parent.isEdge()) {
    return;
  }

  if (!parentId || node.data('parent') !== parentId) {
    node.move({ parent: parentId });
  }
};

function changeNodeId(node, nodeId) {
  // node.data('name',nodeId); // default reset name to Id
  const newNode = {
    data: { id: nodeId, name: node.data('name') },
  };
  // debug-console.log('changeNodeId:	Add new Node :' + nodeId);
  cy.add(newNode);
  cy.edges('[source="' + node.id() + '"]').move({ source: nodeId });
  cy.edges('[target="' + node.id() + '"]').move({ target: nodeId });
  // debug-console.log('changeNodeId:	Copy data :', node.data());
  cy.$id(nodeId).data(node.data());
  // debug-console.log('changeNodeId:	Remove old Node :' + node.id());
  node.remove();
}

function randInt(i) {
  return Math.floor(Math.random() * i);
}

export function updateSelection(selector, ele, clazz) {
  $(selector).removeClass(clazz);
  // // debug-console.log(selector + ' removed class '+clazz);
  $(ele).addClass(clazz);
  // // debug-console.log(ele + ' added class '+clazz);
}

function getDisplayName(ele) {
  let fullName = ele.data('name');
  if (!fullName) {
    fullName = ele.id();
  }
  fullName = fullName.split(' ');
  if (fullName.length > 1) {
    return fullName[fullName.length - 2] + ' ' + fullName[fullName.length - 1];
  }
  return fullName;
}

function animate(eles, style) {
  const jAni = eles.animation({
    style,
    duration: 1000,
  });

  jAni.play();
}

export const clearSelection = () => {
  // cy.$(':selected').forEach((ele) => {
  //	// debug-console.log('selected : '+ele.id());
  // });
  cy.batch(function () {
    cy.elements()
      .unselect()
      .removeClass('selected')
      // .removeClass('ancient')
      .removeClass('green')
      .removeClass('blue')
      .removeClass('red');
  });

  $('#selectingNodes').text('');
  $('#selectingEdges').text('');

  $('#nodeId').val('');
  $('#cyNodeName').val('');
  $('#birthYear').val('');
  $('#imgUrl').val('');
  $('.nodeImg').hide();

  $('#nodeData').val('');
  $('.connectedNode').empty();
  $('#sourceNode').val('').show();
  $('#sourceNode2').val('').show();
  $('#targetNode').val('');
  // // debug-console.log('Clear all .selected ');
};

export function sortById(a, b) {
  return a.id().localeCompare(b.id());
}

export default initCy;

// cy-event.js

// input type is JSON obj with .data
export const updateNodeStyle = (node) => {
  const nodeStyle = createNodeStyle(node);
  cy.style()
    .selector('#' + node.data.id)
    .css(nodeStyle)
    .update();
  // debug-console.log('updateNodeStyle: done', node, nodeStyle);
};

export const updateNodeWidth = (value) => {
  // // debug-console.log('updateNodeWidth: ', value);
  cy.style()
    .selector('node')
    .css({ width: `${value}px`, height: `${value}px` })
    .update();
};

export const onChangeShape = (shape) => {
  // // debug-console.log('update Shape: ', shape);
  document.getElementById('shape').value = shape;
  cy.style().selector('node').css({ shape }).update();
};

const getNodeByName = (nodeName) => {
  // cy.filter('node[name="' + name + '"]');
  return cy.nodes(`[name = "${nodeName}"]`);
};

export const onBtnMainLeaf = () => {
  // const selectingNode = $('#nodeId').text();
  // mainLeaf(selectingNode);
  lGrid();
  $('#btnFocus').click();
};

export const onBtnCollapse = () => {
  animate(cy.nodes().filter('.selected'), collapseStyle);
};

export const onBtnExpand = () => {
  // animate(cy.$('node:selected'), expandStyle);
  animate(cy.nodes().filter('.selected'), expandStyle);
};

export const onBtnHide = () => {
  cy.elements().filter('.selected').addClass('hide');
};

export const onBtnShow = () => {
  cy.elements().filter('.selected').removeClass('hide');
};

export const onBtnShowAll = () => {
  cy.elements().removeClass('hide');
  cy.fit();
};

export const lDagreVisible = () => {
  // correct edges:
  // cy.batch(function () {
  //   cy.edges().forEach((ele) => {
  //     if (
  //       !ele.hasClass('hide') &&
  //       (ele.source().hasClass('hide') || ele.target().hasClass('hide'))
  //     ) {
  //       ele.addClass('hide');
  //     }
  //   });
  // });
  // get only visible nodes and edges
  const eles = cy.elements().filter(
    (ele) =>
      ele.children().length === 0 ||
      (!ele.hasClass('hide') &&
        // ele.selected() &&
        (ele.isNode() || (!ele.source().hasClass('hide') && !ele.target().hasClass('hide')))),
  );
  // debug-console.log('lDagreVisible: eles=', eles.length);
  // for (let index = 0; index < eles.length; index++) {
  //   const ele = eles[index];
  //   // debug-console.log(index + '. ' + ele.id() + ' - ' + ele.data('name'));
  // }
  lDagre(eles);
};

export const getFather = (nodeId, node) => {
  if (!node || node?.empty()) {
    node = cy.getElementById(nodeId);
  }

  const result = node.incomers('node').filter((ele) => {
    return ele.data('gender') === 'm';
  });
  // // debug-console.log(`     getFather : nodeId=${nodeId} -> found=${result.length}`);

  return result.first();
};

export const getMother = (nodeId, node) => {
  if (!node || node?.empty()) {
    node = cy.getElementById(nodeId);
  }

  const result = node.incomers('node').filter((ele) => {
    return ele.data('gender') === 'f';
  });

  // // debug-console.log(`     getMother : nodeId=${nodeId} -> found=${result.length}`);
  return result.first();
};

// predecessors = many ancestors of this node
const findFatherBranch = () => {
  const nodeId = getNodeId();
  const node = cy.getElementById(nodeId);

  const father = getFather(null, node);

  // // debug-console.log('toggle FatherBranch: father=', father?.data('name'));

  if (father) {
    const roots = father.predecessors().roots();
    // debug-console.log('find FatherBranch: roots=', roots);

    const currentNodeSuccessors = node.successors();
    currentNodeSuccessors.merge(node);

    const successors = roots.successors().filter((ele) => !currentNodeSuccessors.contains(ele));
    successors.merge(roots);

    // debug-console.log('find FatherBranch: successors.length=', successors?.length);

    // // debug-console.log('toggle FatherBranch: show=', e.target.checked);
    return successors;
  }
  return null;
};

export const toggleFatherBranch = (e) => {
  const fatherBranch = findFatherBranch();
  if (fatherBranch) {
    cy.batch(function () {
      if (e.target.checked) {
        fatherBranch.removeClass('hide');
      } else {
        fatherBranch.addClass('hide');
      }
    });
    lDagreVisible();

    if (e.target.checked) {
      waitAndRefreshLayout();
    }
  }
};

const findMotherBranch = () => {
  const nodeId = getNodeId();
  const node = cy.getElementById(nodeId);

  const mother = getMother(null, node);

  if (mother) {
    const roots = mother.predecessors().roots();
    // debug-console.log('find MotherBranch: roots=', roots);

    const currentNodeSuccessors = node.successors();
    currentNodeSuccessors.merge(node);

    const successors = roots.successors().filter((ele) => !currentNodeSuccessors.contains(ele));
    successors.merge(roots);

    // debug-console.log('find MotherBranch: successors.length=', successors?.length);

    // // debug-console.log('toggle MotherBranch: show=', e.target.checked);
    return successors;
  }
  return null;
};

export const toggleMotherBranch = (e) => {
  const motherBranch = findMotherBranch();
  if (motherBranch) {
    cy.batch(function () {
      if (e.target.checked) {
        motherBranch.removeClass('hide');
      } else {
        motherBranch.addClass('hide');
      }
    });
    lDagreVisible();

    if (e.target.checked) {
      waitAndRefreshLayout();
    }
  }
};

export const toggleChildren = (e) => {
  const nodeId = getNodeId();
  const node = cy.getElementById(nodeId);
  const successors = node.successors();

  if (successors) {
    cy.batch(function () {
      if (e.target.checked) {
        successors.removeClass('hide');
      } else {
        successors.addClass('hide');
      }
    });
    lDagreVisible();

    if (e.target.checked) {
      waitAndRefreshLayout();
    }
  }
};

export const isNotCompoundNode = (e) => e.children().empty();

export const toggleOthers = (e) => {
  const nodeId = getNodeId();
  const node = cy.getElementById(nodeId);

  const roots = node.predecessors().roots();
  // debug-console.log('roots=', roots);

  const successors = roots.successors();
  // successors = successors.merge(successors.incomers('edge'));

  // debug-console.log('toggle Others: successors.length=', successors?.length);

  // // debug-console.log('toggle MotherBranch: show=', e.target.checked);
  successors.merge(roots);

  const others = cy
    .elements()
    .filter((ele) => !successors.contains(ele))
    .filter(isNotCompoundNode);
  // others.merge(others.incomers('edge'));

  if (others) {
    cy.batch(function () {
      if (e.target.checked) {
        others.removeClass('hide');
      } else {
        others.addClass('hide');
      }
    });
    lDagreVisible();

    if (e.target.checked) {
      waitAndRefreshLayout();
    }
  }
};

function waitAndRefreshLayout() {
  // because lDagre layout is not rendering correctly, re-render it once more
  setTimeout(lDagreVisible, 1000);
}

export const onClearData = () => cy.elements().remove();

export const saveCyNodeInfo = () => {
  const selectingNode = $('#nodeId').first().text();
  const node = cy.getElementById(selectingNode);
  // // debug-console.log(node);
  const nodeId = getNodeId();
  const parentId = $('#parentId').val();
  node.data('name', $('#cyNodeName').val());
  node.data('gender', $('[name=gender]:checked').val());
  node.data('birthYear', $('#birthYear').val());
  node.data('birthMonth', $('#birthMonth').val());
  node.data('birthDay', $('#birthDay').val());
  node.data('img', $('#imgUrl').val());
  node.data('isDead', $('[name=isDead]:checked').val());
  // debug-console.log('onBtnUpdateInfo: ', node);
  updateNode(node, nodeId, parentId);
  showCheckMark();
  return node;
};

const showCheckMark = () => {
  $('#checkMark').fadeIn(1000).fadeOut(1000);
};

function checkBtnUpdateParentsInput() {
  if (
    $('#sourceNode').val() === '' &&
    $('#sourceNode2').val() === '' &&
    $('#targetNode').val() === ''
  ) {
    $('#btnUpdateParents').attr('disabled', true);
  } else {
    $('#btnUpdateParents').attr('disabled', false);
  }
}

// to detect if a node has way to other node or not
export const hasRelation = (rootId, goalId) => {
  if (!rootId || !goalId) {
    return false;
  }
  const aStar = cy.elements().aStar({ root: '#' + rootId, goal: '#' + goalId });
  searchPath = aStar.path;
  return searchPath?.length > 0;
};

// custom filter:
export const onNodeSuggestion = (e, onSelectSuggestion, suggestionFilter) => {
  $('.suggestions').hide();
  const keyword = e.target.value ? e.target.value.toLowerCase() : ''; // this === e.target
  const suggestionsDiv = $(e.target).parent().find('.suggestions').text('');

  let filteredNodes = cy.nodes();
  if (keyword !== '') {
    filteredNodes = filteredNodes.filter(
      (node) => node.data('name')?.toLowerCase().indexOf(keyword) > -1,
    );
  }
  if (suggestionFilter) {
    filteredNodes = filteredNodes.filter(suggestionFilter);
  }
  const suggestions = filteredNodes.each((node) =>
    $(suggestionsDiv).append(createSuggestion(node, keyword, onSelectSuggestion)),
  );
  suggestionsDiv.toggle(suggestions.length > 0);
  checkBtnUpdateParentsInput();
  // // debug-console.log(suggestionsDiv);
};

function createSuggestion(node, keyword, callback) {
  const name = node.data('name');
  if (!name) {
    return null;
  }
  const idx = name.toLowerCase().indexOf(keyword);
  const highlightText =
    name.substring(0, idx) +
    '<span class="highlight">' +
    name.substring(idx, idx + keyword.length) +
    '</span>' +
    name.substring(idx + keyword.length);
  //	// debug-console.log('highlightText', highlightText);
  if (!callback) {
    callback = () => {
      selectNode(node);
    };
  }
  return $('<div>')
    .attr('node-id', node.id())
    .append(highlightText)
    .addClass('nodeSuggestion')
    .click(callback);
}
// End Suggestion

// only call when father does not exist
export const addFather = (sourceNode, destNode) => {
  if (sourceNode.id || sourceNode.name) {
    // debug-console.log('++ Add Father:', sourceNode);

    const currentNodeId = getNodeId();
    const addForCurrentNode = !destNode;

    if (addForCurrentNode) {
      destNode = { id: currentNodeId };
    }
    sourceNode.gender = 'm';

    const edgeId = addEdgeByName(sourceNode, destNode);
    const edge = cy.getElementById(edgeId);
    const father = edge.source();

    if (currentNodeId == destNode.id) {
      $('#father').append(createRelationButton(father, edge));
      $('#sourceNode').val('').hide();
    }

    if (addForCurrentNode) {
      autoArrange();
    }

    return father;
  }
  return null;
};

// only call when mother does not exist
export const addMother = (sourceNode, destNode) => {
  if (sourceNode.id || sourceNode.name) {
    // debug-console.log('++ Add Mother:', sourceNode);

    const currentNodeId = getNodeId();
    const addForCurrentNode = !destNode;

    if (addForCurrentNode) {
      destNode = { id: currentNodeId };
    }

    sourceNode.gender = 'f';

    const edgeId = addEdgeByName(sourceNode, destNode);
    const edge = cy.getElementById(edgeId);
    const mother = edge.source();

    if (currentNodeId == destNode.id) {
      $('#mother').append(createRelationButton(mother, edge));
      $('#sourceNode2').val('').hide();
    }

    if (addForCurrentNode) {
      autoArrange();
    }
    return mother;
  }
  return null;
};

export const addChild = (destNode, skipRefresh) => {
  if (destNode.id || destNode.name) {
    // debug-console.log('++ Add Child :', destNode);
    const srcNode = { id: getNodeId() };

    const edgeId = addEdgeByName(srcNode, destNode);
    const edge = cy.getElementById(edgeId);

    $('#children').append(createRelationButton(edge.target(), edge));
    $('#targetNode').val('');

    if (!skipRefresh) {
      autoArrange();
    }
  }
};

export const addEdgeByName = (sourceNode, destNode, depth) => {
  // // debug-console.log('++ Add edge by Name : ', sourceNode, ' - ', destNode);

  if (!depth) {
    depth = 0;
  }

  // Add source Node:
  let cySrcNode;
  let cyDestNode;
  if (!Number.isNaN(parseInt(sourceNode.id, 10))) {
    // probably an Id
    cySrcNode = cy.$id(sourceNode.id).first();
  }
  if (!cySrcNode || cySrcNode.empty()) {
    cySrcNode = addNode(sourceNode, depth);
  }

  // Add Dest Node:
  let destName = destNode.name;
  if (!Number.isNaN(parseInt(destNode.id, 10))) {
    // probably an Id
    cyDestNode = cy.$id(destNode.id).first();
  }
  if (!cyDestNode || cyDestNode.empty()) {
    cyDestNode = addNode(destNode, depth + 1);
  } else {
    destName = cyDestNode.data('name'); // correct edge name
  }

  // Add Edge:
  const id = cySrcNode.id() + '-' + cyDestNode.id();
  const edgeName = destName; // set edgeName as destNode name

  addEdge(id, edgeName, cySrcNode.id(), cyDestNode.id());
  return id;
};

function addEdge(id, name, sourceId, destId) {
  // // debug-console.log('++ Add edge (ID): ', sourceId, ' - ', destId);
  if (cy.getElementById(id).empty()) {
    const edge = {
      data: { id, name, source: sourceId, target: destId },
      pannable: true, // whether dragging on the edge causes panning
    };
    // // debug-console.log(data);
    cy.add(edge);

    // autoArrange();
    // refreshSummary();
  }
}

export const onRelationSelection = (e) => {
  // when click on suggestion
  const nodeId = getNodeId(e);
  // const aStarSearch = testAStar(getNodeId(), nodeId);
  $('#destinationId').val(cy.nodes('#' + nodeId).data('name'));
};

export const onBtnUpdateParents = () => {
  // debug-console.log('Update Parents/Child:');
  addFather({ name: $('#sourceNode').val() });
  addMother({ name: $('#sourceNode2').val() });
  addChild({ name: $('#targetNode').val() });
  // selectNode(cy.nodes('#' + getNodeId()));
};

export const onBtnFocus = () => {
  const selectingNode = $('#nodeId').text();
  let node = cy.getElementById(selectingNode);

  if (node.empty()) {
    node = cy.nodes(':selected');
  }

  if (node.empty()) {
    node = cy.nodes().first();
  }

  zoomLevel = cy.zoom();

  // // debug-console.log(
  //   'Focus: ' +
  //     node.id() +
  //     ' - ' +
  //     node.data('name') +
  //     ' , zoomLevel=[' +
  //     $('#zoomLevel').text() +
  //     '] : ' +
  //     zoomLevel,
  // );
  cy.animate({
    center: {
      eles: node,
    },
    // fit : {
    // eles :node,
    // padding : 200
    // },
    zoom: zoomLevel,
    duration: 1000,
  });
};

// cy-layout.js

function layout(eles, options) {
  // // debug-console.log('layout: ', options.name, options);

  if (!eles) {
    const selectings = cy.nodes().filter('.selected');
    if (selectings.size() > 2) {
      // debug-console.log('layout: choose .selected size=', selectings.size());
      eles = selectings;
    }
    // else {
    //   // debug-console.log('layout: choose cy');
    //   eles = cy;
    // }
  }
  // const newLayout = eles.layout(options);
  if (eles) {
    options = { ...options, eles };
  }
  const newLayout = cy.layout(options);
  newLayout.run();

  // // debug-console.log('layout: finished. layout=', newLayout);
  // debug:
  // const { animations } = newLayout;
  // for (let index = 0; index < animations.length; index++) {
  //   const ani = animations[index];
  //   // const ele = ani.target;
  //   // debug-console.log(index + '. ', ani); // + ele.id() + ' - ' + ele.data('name'));
  // }

  // if (true) {
  // 	cy.center();
  // cy.fit();
  // 	cy.zoom(zoomLevel);
  // }
}

export const lDagre = (eles, additionalOpt) => {
  // (_roots) { currently not using roots, use null
  // // debug-console.log('dagre()');
  const option = { ...lDagreOptions, ...additionalOpt };

  if (eles) {
    if (eles.length > 1) {
      layout(eles, option);
    }
  } else {
    layout(null, option);
  }

  updateSelection('.btn-layout', '#lDagre', 'border-green');
};

export function lElk(roots) {
  // // debug-console.log('elk()');
  layout(lElkOption);
  updateSelection('.btn-layout', '#lElk', 'border-green');
}

export function lBfs(roots) {
  // debug-console.log('lBfs(). Skip updateId()');
  // updateId();
  const options = {
    name: 'breadthfirst',

    fit: true, // whether to fit the viewport to the graph
    directed: true, // whether the tree is directed downwards (or edges can point in any direction if false)
    padding: 100, // padding on fit
    circle: false, // put depths in concentric circles if true, put depths top down if false
    grid: true, // whether to create an even grid into which the DAG is placed (circle:false only)
    spacingFactor: 4, // positive spacing factor, larger => more space between nodes (N.B. n/a if causes overlap)
    boundingBox: undefined, // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true, // prevents node overlap, may overflow boundingBox if not enough space
    nodeDimensionsIncludeLabels: false, // Excludes the label when calculating node bounding boxes for the layout algorithm
    roots, // the roots of the trees
    maximal: false, // whether to shift nodes down their natural BFS depths in order to avoid upwards edges (DAGS only)
    animate: true, // whether to transition the node positions
    animationDuration: 1000, // duration of animation in ms if enabled
    animationEasing: undefined, // easing of animation if enabled,
    animateFilter: (_node, _i) => true, // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined, // callback on layoutready
    stop: undefined, // callback on layoutstop
    transform: (_node, aPosition) => aPosition, // transform a given node position. Useful for changing flow direction in discrete layouts
  };

  layout(options);
  updateSelection('.btn-layout', '#lBfs', 'border-green');
}

export function lGrid() {
  // debug-console.log('lGrid(). postition()');
  // position();
  const lGridOption = {
    name: 'grid',

    fit: true, // whether to fit the viewport to the graph
    padding: 50, // padding used on fit
    boundingBox: undefined, // constrain layout bounds; { x1, y1, x2, y2 } or { x1, y1, w, h }
    avoidOverlap: true, // prevents node overlap, may overflow boundingBox if not enough space
    avoidOverlapPadding: 10, // extra spacing around nodes when avoidOverlap: true
    nodeDimensionsIncludeLabels: false, // Excludes the label when calculating node bounding boxes for the layout algorithm
    spacingFactor: 2, // Applies a multiplicative factor (>0) to expand or compress the overall area that the nodes take up
    condense: false, // uses all available space on false, uses minimal space on true
    rows: undefined, // force num of rows in the grid
    cols: undefined, // force num of columns in the grid
    position: gridPosition, // returns { row, col } for element
    sort: sortById, // a sorting function to order the nodes; e.g. function(a, b){ return a.data('weight') - b.data('weight') }
    animate: true, // whether to transition the node positions
    animationDuration: 500, // duration of animation in ms if enabled
    animationEasing: undefined, // easing of animation if enabled
    animateFilter: (_node, _i) => true, // a function that determines whether the node should be animated.  All nodes animated by default on animate enabled.  Non-animated nodes are positioned immediately when the layout starts
    ready: undefined, // callback on layoutready
    stop: undefined, // callback on layoutstop
    transform: (_node, aPosition) => aPosition, // transform a given node position. Useful for changing flow direction in discrete layouts
  };

  layout(lGridOption);
  updateSelection('.btn-layout', '#lGrid', 'border-green');
}

function gridPosition(node) {
  const row = node.data('depth');
  let col = node.data('col');
  if (!col || col === '') {
    col = node.data('offset');
  }

  // debug-console.log(    'Grid : ' + node.id() + ' - name: ' + node.data('name') + ' : row=' + row + ', col=' + col,  );
  return { row, col };
}

export function lConcentric() {
  // // debug-console.log('lConcentric()');
  layout(lConcentricOption);
  updateSelection('.btn-layout', '#lConcentric', 'border-green');
}

export function lCose() {
  // // debug-console.log('lCose()');
  layout(lCoseOption);
  updateSelection('.btn-layout', '#lCose', 'border-green');
}

export function lCircle() {
  layout(lCircleOption);
  updateSelection('.btn-layout', '#lCircle', 'border-green');
}

export function lPreset() {
  layout(presetOptions);
  updateSelection('.btn-layout', '#lPreset', 'border-green');
}
